import parse from 'html-react-parser';
import moment from 'moment';
import { EMAIL_TASK_ACTIONS } from '../constants/EntityActions';

export function base64Encode(subject) {
  return Buffer.from(subject).toString('base64');
}

export function stripHtml(html) {
  let textPart = '';
  parse(html, {
    replace: (domNode) => {
      if (domNode.type === 'text') {
        textPart += domNode.data;
      }
    },
  });

  return textPart;
}

export function base64ToString(encodedString) {
  if (!encodedString) {
    return '';
  }
  return Buffer.from(encodedString, 'base64').toString();
}

export function formatUserName(email) {
  return email.trim().split(/ +/).join(' ');
}

// Function to get task payload for email
export function getEmailTaskName(taskCategory, values) {
  switch (taskCategory) {
    case EMAIL_TASK_ACTIONS.FOLLOW_UP:
      return `Follow up on email ${values?.subject || 'No Subject'}`;
    default:
      return null;
  }
}

// Function to get task payload for email
export function getEmailTaskPayload(
  taskCategory,
  user,
  level,
  entityId,
  values,
  recipientIds,
  emailTaskOptions
) {
  const currentDateTime = moment().format('dddd, MMMM D, YYYY, h:mm:ss A');

  let combinedRecipientIds = [
    ...Object.values(recipientIds?.to),
    ...Object.values(recipientIds?.cc),
    ...Object.values(recipientIds?.bcc),
  ];

  if (level === 'contact') {
    combinedRecipientIds.push(entityId);
  }

  combinedRecipientIds = [...new Set(combinedRecipientIds)];

  const payload = {
    name: getEmailTaskName(taskCategory, values),
    _values: {
      assigneeId: user.userId,
      dueDate: emailTaskOptions.dueDate,
      status: emailTaskOptions.status,
      priority: emailTaskOptions.priority,
      description: `<p>Regarding email: ${
        values?.subject || 'No Subject'
      } sent on ${currentDateTime}`,
      entity: level?.toUpperCase(),
      [`${level !== 'contact' ? level : 'organization'}Id`]:
        level !== 'contact' ? entityId : undefined,
      contacts: combinedRecipientIds,
      activityTypeId: 1,
      assigneeType: 'USER',
      repeatConfiguration: {},
    },
    checkList: [],
    watchers: [{ watcherType: 'USER', taskWatcherId: user.userId }],
    scopedFiles: values.attachments.map((item) => {
      return {
        fileMetaDataId: item.response.fileMetaDataId,
        fileType: item.response.fileType,
        displayName: item.response.displayName,
        source: 2,
        uid: item.uid,
      };
    }),
  };
  return payload;
}
